import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    additionalSteps: ['Choose a subscription'],
    cta: 'Continue',
    moreInfoLink: 'Learn more about beneficial owners',
    page: {
      subtitle:
        'In order to open the professional account of {companyName} we need you to complete some information. This will be the case for all beneficial owners of the company.',
      title: 'Welcome {name}!',
    },
    steps: ['Some information about you', 'A proof of identity'],
    stepsTitle: 'We will ask you:',
  },

  fr: {
    additionalSteps: ['Choisir un abonnement'],
    cta: 'Continuer',
    moreInfoLink: 'En savoir plus sur les bénéficiaires effectifs',
    page: {
      subtitle:
        'Afin d’ouvrir le compte pro de {companyName}, nous avons besoin que vous complétiez les informations suivantes au même titre que les autres bénéficiaires effectifs de l’entreprise.',
      title: 'Bienvenue {name}\u00a0!',
    },
    steps: ['Quelques informations personnelles', 'Une preuve d’identité'],
    stepsTitle: 'Nous allons vous demander\u00a0:',
  },
} as const);

export default locales;
